import { useEffect, useState } from "react";
import { Mic, ArrowUpRight } from "lucide-react";
import Sparkline from "./Sparkline";
import api from "../lib/api";

// Plots pronunciation accuracy over time from Whisper-scored read-aloud
// attempts. Same visual language as the Sight Words sparkline.
export default function ReadAloudTrendCard() {
    const [data, setData] = useState(null);

    useEffect(() => {
        api.get("/stats/read-aloud-timeline")
            .then((r) => setData(r.data))
            .catch(() => setData({ points: [], personal_best: 0, attempts: 0, first: 0, latest: 0 }));
    }, []);

    if (!data) return null;

    const values = data.points.map((p) => p.accuracy);
    const growth = data.attempts >= 2 ? data.latest - data.first : null;

    return (
        <section className="card-rw p-7 mb-10" data-testid="read-aloud-trend-card">
            <div className="flex items-start justify-between flex-wrap gap-4 mb-5">
                <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-[#E0EDE6] flex items-center justify-center flex-shrink-0 mt-0.5">
                        <Mic className="w-5 h-5 text-[#2D5D4E]" strokeWidth={1.6} />
                    </div>
                    <div>
                        <p className="label-eyebrow mb-1 flex items-center gap-1">
                            <ArrowUpRight className="w-3.5 h-3.5" /> Pronunciation
                        </p>
                        <h2 className="text-2xl font-medium text-[#1C2321]" style={{ fontFamily: "Outfit" }}>
                            Read-Aloud accuracy
                        </h2>
                        <p className="text-[#515B57]">
                            How closely your reading matched the passage — across your last {data.attempts || 0} {data.attempts === 1 ? "recording" : "recordings"}.
                        </p>
                    </div>
                </div>
                <div className="text-right">
                    <p className="text-5xl font-semibold text-[#2D5D4E]" style={{ fontFamily: "Outfit" }} data-testid="read-aloud-best-value">
                        {data.personal_best}%
                    </p>
                    <p className="text-sm text-[#819888]">your best · accuracy</p>
                </div>
            </div>
            <div className="overflow-x-auto pb-1">
                <Sparkline
                    values={values}
                    width={Math.max(320, values.length * 30)}
                    height={120}
                    personalBest={data.personal_best || null}
                />
            </div>
            {growth != null && growth > 0 && (
                <p className="mt-4 text-[#2D5D4E] font-medium" data-testid="read-aloud-growth">
                    You're up <span className="font-semibold">{growth} points</span> since your first recording. That's ear-training paying off.
                </p>
            )}
            {data.attempts === 0 && (
                <p className="mt-4 text-[#515B57]">
                    Tap the microphone on any lesson passage to record yourself reading. Every attempt lands here.
                </p>
            )}
        </section>
    );
}
